export default {
  add_products: '+ Artikel hinzufügen',
};
